import { Button, CircularProgress } from "@chakra-ui/react"
import { t } from "i18next"
import { FC } from "react"
import useConfig from "src/hooks/useConfig"

type Props = {}

export const Conditional404Button: FC<Props> = () => {
  const { platformName } = useConfig()
  switch (platformName) {
    case "loading":
      return (
        <CircularProgress
          isIndeterminate
          value={30}
          color={"orange.400"}
          thickness="12px"
          size={"20px"}
        />
      )
    case "Utta":
      return (
        <Button
          bg="#1ac541"
          color={"white"}
          _hover={{
            bg: "#17a939"
          }}
          onClick={() => window.open("https://utta.app/", "_self")}
        >
          {t("Back to utta.app")}
        </Button>
      )
    case "LearnMachine":
      return (
        <Button
          bg="#1ac541"
          color={"white"}
          _hover={{
            bg: "#17a939"
          }}
          onClick={() => window.open("https://learnmachine.ai/", "_self")}
        >
          {t("Back to learnmachine.ai")}
        </Button>
      )
    default:
    case "LiveSell":
      return (
        <Button
          bg="#1ac541"
          color={"white"}
          _hover={{
            bg: "#17a939"
          }}
          onClick={() => window.open("https://livesell.co/", "_self")}
        >
          {t("Back to LiveSell.co")}
        </Button>
      )
  }
}
